<template>
	<div>
		<template v-if="isLoading">
			<el-row :gutter="20">
				<el-col
					v-loading="isLoading"
					:span="24"
					style="height: 500px; padding: 1rem; background: #ffffff"
				>
					<div class="bg-white"></div>
				</el-col>
			</el-row>
		</template>
		<template v-else>
			<el-row :gutter="20">
				<el-col
					v-loading="isLoading"
					:span="24"
					style="padding: 1rem; background: #ffffff"
				>
					<div class="bg-white">
						<el-row type="flex" class="row-bg" justify="end">
							<el-col :span="4">
								<div class="grid-content">
									<span
										><span
											class="category-link"
											:class="
												graphFilterBy == 'location' ? 'selected-category' : ''
											"
											@click="graphFilterBy = 'location'"
											>By Location</span
										>
										|
										<span
											class="category-link"
											:class="
												graphFilterBy == 'user' ? 'selected-category' : ''
											"
											@click="graphFilterBy = 'user'"
											>By User</span
										></span
									>
								</div>
							</el-col>
							<el-col v-if="dashboardTab == 'audit'" :span="4">
								<div class="grid-content bg-purple-light">
									<el-select
										v-model="selectedGraphValueType"
										style="width: 100%"
										placeholder="Score %"
										filterable
										size="mini"
									>
										<el-option
											:value="'score_percentage'"
											:label="'Score %'"
										></el-option>
										<el-option
											:value="'completion_percentage'"
											:label="'Completion %'"
										></el-option>
									</el-select>
								</div>
							</el-col>
							<el-col :span="2" class="text-right">
								<div class="grid-content">
									<span
										v-if="!viewDetails"
										class="link-text"
										@click="viewDetails = true"
										>View Details</span
									>
									<span
										v-else-if="viewDetails"
										class="link-text"
										@click="viewDetails = false"
										>Hide Details</span
									>
								</div>
							</el-col>
						</el-row>
						<el-row :gutter="20" style="margin-top: 10px">
							<el-col :span="8"></el-col>
							<el-col :span="6" class="text-center">
								<div class="grid-content">
									<h4>
										Performance -
										{{
											graphFilterBy == "location" ? "By Location" : "By User"
										}}
									</h4>
								</div>
							</el-col>
							<el-col :span="4"></el-col>
							<el-col :span="6" class="text-right">
								<!-- <div v-if="dashboardTab == 'audit'" class="grid-content">
									<span>
										<span class="grade-title">Grade</span>
										<span class="grade-text grade-a">A</span>
										<span class="grade-text grade-b">B</span>
										<span class="grade-text grade-c">C</span>
										<span class="grade-text grade-d">D</span>
										<span class="grade-text grade-fail">Fail</span>
									</span>
								</div> -->
							</el-col>
						</el-row>
					</div>
					<location-insights-dashboard-graph
						:graph-labels="graphLabelsArr"
						:graph-colors="graphColorsArr"
						:graph-values="graphValuesArr"
						:selected-graph-value-type="selectedGraphValueType"
					></location-insights-dashboard-graph>
				</el-col>
			</el-row>
			<location-performance-details
				v-if="viewDetails"
				:graph-labels="graphLabelsArr"
				:graph-colors="graphColorsArr"
				:graph-values="graphValuesArr" 
				:get-outlet-name="getOutletName"
				:selected-graph-value-type="selectedGraphValueType"
				:view-details="viewDetails"
				:height="500"
				:table-data="table_data"
				:outlet="outlet"
				:graph-filter-by="graphFilterBy"
				:dashboard-tab="dashboardTab"
				:from-date="fromDate"
				:to-date="toDate"
				:intermediate-category="intermediateCategory"
				:audit-intermediate-categories="auditIntermediateCategories"
				:task-intermediate-categories="taskIntermediateCategories"
				:outlet-lists="outletLists"
				:calendar-type-list="calendarTypeList"
				:selected-type="selectedType"
				:selected-intermediate-category="selectedIntermediateCategory"
				@closeLocationPerformanceDetails="handleCloseLocationPerformanceDetails"
				@changedSelectedOutlet="changedSelectedOutlet"
				@changedDateTypeViewList="changedDateTypeView"
				@changedFromDate="changedFromDate"
				@changedToDate="changedToDate"
				@changedSelectedAuditType="changedSelectedAuditType"
			></location-performance-details>
		</template>
	</div>
</template>

<script>
import LocationInsightsDashboardGraph from "./LocationPerformanceDetails/LocationInsightsDashboardGraph.vue";
import LocationPerformanceDetails from "./LocationPerformanceDetails/LocationPerformanceDetails.vue";
import { EventBus } from "../../../../../eventBus";
import { serverAddr } from "../../../../../networkConfig";
export default {
	name: "LocationInsightsGraph",
	components: {
		LocationInsightsDashboardGraph,
		LocationPerformanceDetails
	},
	props: {
		fromDate: {
			type: String,
			default: "",
		},
		toDate: {
			type: String,
			default: "",
		},
		outlet: {
			type: String,
			default: null,
		},
		getOutletName: {
			type: String,
			default: null,
		},
		intermediateCategory: {
			type: String,
			default: "",
		},
		dashboardTab: {
			type: String,
			default: "audit",
		},
		auditIntermediateCategories: {
			type: Array,
			required: false,
			default: () => []
		},
		taskIntermediateCategories: {
			type: Array,
			required: false,
			default: () => []
		},
		outletLists: {
      required: true,
      type: Array,
    },
    calendarTypeList: {
      required: true,
      type: Array
    },
		selectedType: {
      type: String,
      required: true,
    },
    selectedIntermediateCategory: {
      type: String,
      default: null
    }
	},
	data() {
		return {
			viewDetails: false,
			selectedGraphValueType: "score_percentage",
			performanceResults: [],
			graphFilterBy: "location",
			auditReportsLocations: [],
			table_data: [],
			isLoading: false,
			performanceResultDetails: [],
			graphColorsArr: [],
			graphLabelsArr: [],
			graphValuesArr: [],
		};
	},
	watch: {
		graphFilterBy(newValue, oldValue) {
			if (newValue == "location") {
				this.getPerformanceByLocation();
			}
			if (newValue == "user") {
				this.getPerformanceByUser();
			}
		},
		performanceResults(newValue, oldValue) {
			this.reRenderGraph(newValue);
			let localResult = newValue;
			let tempResult;
			let localTempResult;
			let tempResultTwo;
			if(this.outlet === null || this.outlet === '' || this.outlet === 'all' || this.outlet === 'All') {
				this.table_data = [...newValue];
			} else {
				let tempTableData = [...newValue];
				let tempConsidatedObject = {};
				for(let i = 0; i < tempTableData.length; i++) {
					if(this.isEmptyObject(tempConsidatedObject)) {
						tempConsidatedObject = {...tempTableData[i]};
					} else {
						tempConsidatedObject.assigned = tempConsidatedObject.assigned + tempTableData[i].assigned;
						tempConsidatedObject.completed = tempConsidatedObject.completed + tempTableData[i].completed;
						tempConsidatedObject.due_date = tempTableData[i].due_date;
						tempConsidatedObject.overdue = tempConsidatedObject.overdue + tempTableData[i].overdue;
						tempConsidatedObject.total = tempConsidatedObject.total + tempTableData[i].total;
						tempConsidatedObject.unassigned = tempConsidatedObject.unassigned + tempTableData[i].unassigned;
					}
				}
				if(!this.isEmptyObject(tempConsidatedObject)) {
					tempConsidatedObject.completion_rate = ((tempConsidatedObject.completed / tempConsidatedObject.total) * 100);
				}
				this.table_data = [tempConsidatedObject];
			}
			if (this.dashboardTab == "other") {
				localTempResult = [...localResult];
				if (!this.outlet) {
					localTempResult.sort((a, b) => b.completion_rate - a.completion_rate);
				}
				tempResult = localTempResult.slice(0, 10);
				tempResultTwo = [...localTempResult];
			} else if (this.dashboardTab == "audit") {
				localTempResult = [...localResult];
				if (!this.outlet) {
					if(this.selectedGraphValueType == "score_percentage") {
						localTempResult.sort(
							(a, b) => b.yes_no_points_percentage - a.yes_no_points_percentage
						);
					} else {
						localTempResult.sort(
							(a, b) => b.completion_rate - a.completion_rate
						);
					}
					
				}
				tempResult = localTempResult.slice(0, 10);
				tempResultTwo = [...localTempResult];
			}

			let locationLocations = [];
			let localBackgroundColors = [];
			let localGraphData = [];

			let locationLocationsTwo = [];
			let localBackgroundColorsTwo = [];
			let localGraphDataTwo = [];

			for (let i = 0; i < tempResult.length; i++) {
				if (this.outlet) {
					locationLocations.push(tempResult[i].due_date);
				} else {
					locationLocations.push(this.titleCase(tempResult[i].name));
				}
				if (
					this.selectedGraphValueType == "score_percentage" &&
					this.dashboardTab == "audit"
				) {
					localBackgroundColors.push("#d26300");
					localGraphData.push(tempResult[i].yes_no_points_percentage);
				} else if (
					this.selectedGraphValueType == "completion_percentage" &&
					this.dashboardTab == "audit"
				) {
					localBackgroundColors.push("#d26300");
					localGraphData.push(tempResult[i].completion_rate);
				} else if (this.dashboardTab == "other") {
					localBackgroundColors.push("#d26300");
					localGraphData.push(tempResult[i].completion_rate);
				}
			}

			for (let i = 0; i < tempResultTwo.length; i++) {
				if (this.outlet) {
					locationLocationsTwo.push(tempResultTwo[i].due_date);
				} else {
					let labelName = this.titleCase(tempResultTwo[i].name);
					if(this.graphFilterBy == 'user') {
						labelName = labelName + '__' + this.titleCase(tempResultTwo[i].outlet_name);
					}
					locationLocationsTwo.push(labelName);
				}
				if (
					this.selectedGraphValueType == "score_percentage" &&
					this.dashboardTab == "audit"
				) {
					localBackgroundColorsTwo.push("#d26300");
					localGraphDataTwo.push(tempResultTwo[i].yes_no_points_percentage);
				} else if (
					this.selectedGraphValueType == "completion_percentage" &&
					this.dashboardTab == "audit"
				) {
					localBackgroundColorsTwo.push("#d26300");
					localGraphDataTwo.push(tempResultTwo[i].completion_rate);
				} else if (this.dashboardTab == "other") {
					let color = this.getGraphValueColor(tempResultTwo.completion_rate);
					localBackgroundColorsTwo.push(color);
					localGraphDataTwo.push(tempResultTwo[i].completion_rate);
				}
			}

			this.graphColorsArr = localBackgroundColorsTwo;
			this.graphLabelsArr = locationLocationsTwo;
			this.graphValuesArr = localGraphDataTwo;
		},
		selectedGraphValueType(newValue, oldValue) {
			let localResult = [...this.performanceResults];
			let tempResult;
			let localTempResult;
			let tempResultTwo;
			if(this.outlet === null || this.outlet === '' || this.outlet === 'all' || this.outlet === 'All') {
				this.table_data = [...localResult];
			} else {
				let tempTableData = [...localResult];
				let tempConsidatedObject = {};
				for(let i = 0; i < tempTableData.length; i++) {
					if(this.isEmptyObject(tempConsidatedObject)) {
						tempConsidatedObject = {...tempTableData[i]};
					} else {
						tempConsidatedObject.assigned = tempConsidatedObject.assigned + tempTableData[i].assigned;
						tempConsidatedObject.completed = tempConsidatedObject.completed + tempTableData[i].completed;
						tempConsidatedObject.due_date = tempTableData[i].due_date;
						tempConsidatedObject.overdue = tempConsidatedObject.overdue + tempTableData[i].overdue;
						tempConsidatedObject.total = tempConsidatedObject.total + tempTableData[i].total;
						tempConsidatedObject.unassigned = tempConsidatedObject.unassigned + tempTableData[i].unassigned;
					}
				}
				if(!this.isEmptyObject(tempConsidatedObject)) {
					tempConsidatedObject.completion_rate = ((tempConsidatedObject.completed / tempConsidatedObject.total) * 100);
				}
				this.table_data = [tempConsidatedObject];
			}
			if (this.dashboardTab == "other") {
				localTempResult = [...localResult];
				if (!this.outlet) {
					localTempResult.sort((a, b) => b.completion_rate - a.completion_rate);
				}
				tempResult = localTempResult.slice(0, 10);
				tempResultTwo = [...localTempResult];
			} else if (this.dashboardTab == "audit") {
				localTempResult = [...localResult];
				if (!this.outlet) {
					if(this.selectedGraphValueType == "score_percentage") {
						localTempResult.sort(
							(a, b) => b.yes_no_points_percentage - a.yes_no_points_percentage
						);
					} else {
						localTempResult.sort((a, b) => b.completion_rate - a.completion_rate);
					}
				}
				tempResult = localTempResult.slice(0, 10);
				tempResultTwo = [...localTempResult];
			}

			let locationLocations = [];
			let localBackgroundColors = [];
			let localGraphData = [];

			let locationLocationsTwo = [];
			let localBackgroundColorsTwo = [];
			let localGraphDataTwo = [];

			for (let i = 0; i < tempResult.length; i++) {
				if (this.outlet) {
					locationLocations.push(tempResult[i].due_date);
				} else {
					locationLocations.push(this.titleCase(tempResult[i].name));
				}
				if (
					this.selectedGraphValueType == "score_percentage" &&
					this.dashboardTab == "audit"
				) {
						let color = this.getGraphValueColor(tempResultTwo.yes_no_points_percentage);
						localBackgroundColorsTwo.push(color);
						localGraphData.push(tempResult[i].yes_no_points_percentage);
				} else if (
					this.selectedGraphValueType == "completion_percentage" &&
					this.dashboardTab == "audit" &&
					this.graphFilterBy == 'location'
				) {
					let color = this.getGraphValueColor(tempResultTwo.completion_rate);
					localBackgroundColorsTwo.push(color);
					localGraphData.push(tempResult[i].completion_rate);
				} else if (
					this.selectedGraphValueType == "completion_percentage" &&
					this.dashboardTab == "audit" &&
					this.graphFilterBy == 'user'
				) {
					let color = this.getGraphValueColor(tempResultTwo.completion_rate);
					localBackgroundColorsTwo.push(color);
					localGraphData.push(tempResult[i].completion_rate);
				} else if (this.dashboardTab == "other") {
					localBackgroundColors.push("#d26300");
					localGraphData.push(tempResult[i].completion_rate);
				}
			}

			for (let i = 0; i < tempResultTwo.length; i++) {
				if (this.outlet) {
					locationLocationsTwo.push(tempResultTwo[i].due_date);
				} else {
					let labelName = this.titleCase(tempResultTwo[i].name);
					if(this.graphFilterBy == 'user') {
						labelName = labelName + '__' + this.titleCase(tempResultTwo[i].outlet_name);
					}
					locationLocationsTwo.push(labelName);
				}
				if (
					this.selectedGraphValueType == "score_percentage" &&
					this.dashboardTab == "audit"
				) {
					let color = this.getGraphValueColor(tempResultTwo.yes_no_points_percentage);
					localBackgroundColorsTwo.push(color);
					localGraphDataTwo.push(tempResultTwo[i].yes_no_points_percentage);
				} else if (
					this.selectedGraphValueType == "completion_percentage" &&
					this.dashboardTab == "audit"
				) {
					let color = this.getGraphValueColor(tempResultTwo.completion_rate);
					localBackgroundColorsTwo.push(color);
					localGraphDataTwo.push(tempResultTwo[i].completion_rate);
				} else if (this.dashboardTab == "other") {
					if (this.outlet) {
						let color = this.getGraphValueColor(tempResultTwo.completion_rate);
						localBackgroundColorsTwo.push(color);
					} else {
						localBackgroundColorsTwo.push("#d26300");
					}
					localGraphDataTwo.push(tempResultTwo[i].completion_rate);
				}
			}
			
			this.graphColorsArr = localBackgroundColorsTwo;
			this.graphLabelsArr = locationLocationsTwo;
			this.graphValuesArr = localGraphDataTwo;
		},
		intermediateCategory(oldValue, newValue) {
			if (this.graphFilterBy == "location") {
				this.getPerformanceByLocation();
			} else {
				this.getPerformanceByUser();
			}
		},
		dashboardTab(oldValue, newValue) {
			if (this.graphFilterBy == "location") {
				this.getPerformanceByLocation();
			} else {
				this.getPerformanceByUser();
			}
			if (newValue == "other") {
				this.selectedGraphValueType = "completion_percentage";
			} else {
				if (this.selectedGraphValueType != "score_percentage") {
					this.selectedGraphValueType = "score_percentage";
				}
			}
		},
		fromDate(newValue, oldValue) {
			if (this.graphFilterBy == "location") {
				this.getPerformanceByLocation();
			} else {
				this.getPerformanceByUser();
			}
		},
		toDate(newValue, oldValue) {
			if (this.graphFilterBy == "location") {
				this.getPerformanceByLocation();
			} else {
				this.getPerformanceByUser();
			}
		},
		outlet(newValue, oldValue) {
			if (this.graphFilterBy == "location") {
				this.getPerformanceByLocation();
			} else {
				this.getPerformanceByUser();
			}
		},
	},
	mounted() {
		const self = this;
		EventBus.$on("fetchGraphDetails", function (payload) {
			self.getPerformanceByLocation();
		});
		EventBus.$on("callAllGraphs", function (payload) {
			self.getPerformanceByLocation();
		});
		EventBus.$on("insightsDateUpdated", function (payload) {
			self.getPerformanceByLocation();
		});
	},
	beforeDestroy() {
		EventBus.$off();
		this.$off();
	},
	methods: {
		changedSelectedOutlet(event) {
			this.$emit('changedSelectedOutlet', event);
		},
		changedDateTypeView(event) {
			this.$emit('changedDateTypeViewList', event);
		},
		changedFromDate(event) {
			this.$emit('changedFromDate', event);
		},
		changedToDate(event) {
			this.$emit('changedToDate', event);
		},
		changedSelectedAuditType(event) {
			this.$emit('changedSelectedAuditType', event);
		},
		isEmptyObject(obj) {
			for(let prop in obj) {
				if(Object.prototype.hasOwnProperty.call(obj, prop)) {
					return false;
				}
			}
			return JSON.stringify(obj) === JSON.stringify({});
		},
		handleCloseLocationPerformanceDetails() {
			this.viewDetails = false;
		},
		getPerformanceByLocation() {
			const params = {
				basics: "outlet",
				include_dates: false,
				category_wise: false,
				include_cycle_data: true,
				start_date: this.fromDate,
				end_date: this.toDate,
				filters: {
					outlets: [],
				},
				designation: null,
				main_category: this.dashboardTab,
				intermediate_category: this.intermediateCategory,
			};
			if (this.outlet) {
				params.filters.outlets.push(this.outlet);
				params.include_dates = true;
			}
			let url =
				this.dashboardTab == "audit"
					? "/bk_task_assignment/report/?get_all=true"
					: "/task_assignment/report/?get_all=true";
			if(this.fromDate && this.toDate) {
			this.isLoading = true;
			serverAddr
				.post(url, params)
				.then((response) => {
					const responseData = JSON.parse(response.data);
					let responseResults = responseData.results;
					if (this.outlet && responseResults && responseResults.length && responseResults[0] && responseResults[0].data) {
						responseResults = [...responseResults[0].data];
					}
					if (this.dashboardTab == "other") {
						if (!this.outlet) {
							responseResults.sort(
								(a, b) => b.completion_rate - a.completion_rate
							);
						}
					} else if (this.dashboardTab == "audit") {
						if (!this.outlet) {
							responseResults.sort(
								(a, b) =>
									b.yes_no_points_percentage - a.yes_no_points_percentage
							);
						}
					}
					this.performanceResults = [...responseResults];
				})
				.catch((error) => {
					console.error("Performance by location!", error);
				})
				.finally((result) => {
					this.isLoading = false;
					EventBus.$emit("updateGraphWidth", true);
				});
			}
		},
		getPerformanceByUser() {
			const params = {
				basics: this.dashboardTab == "audit" ? "user" : "employee",
				include_dates: false,
				category_wise: false,
				include_cycle_data: true,
				start_date: this.fromDate,
				end_date: this.toDate,
				filters: {
					outlets: [],
				},
				designation: null,
				main_category: this.dashboardTab,
				intermediate_category: this.intermediateCategory,
			};
			if (this.outlet) {
				params.filters.outlets.push(this.outlet);
				params.include_dates = true;
			}
			let url =
				this.dashboardTab == "audit"
					? "/bk_task_assignment/report/?get_all=true"
					: "/task_assignment/report/?get_all=true";
			if(this.fromDate && this.toDate) {
			this.isLoading = true;
			serverAddr
				.post(url, params)
				.then((response) => {
					const responseData = JSON.parse(response.data);
					let responseResults = responseData.results;
					if (this.outlet && responseResults && responseResults.length && responseResults[0] && responseResults[0].data) {
						responseResults = [...responseResults[0].data];
					}
					if (this.dashboardTab == "other") {
						if (!this.outlet) {
							responseResults.sort(
								(a, b) => b.completion_rate - a.completion_rate
							);
						}
					} else if (this.dashboardTab == "audit") {
						if (!this.outlet) {
							responseResults.sort(
								(a, b) =>
									b.yes_no_points_percentage - a.yes_no_points_percentage
							);
						}
					}
					this.performanceResults = [...responseResults];
				})
				.catch((error) => {
					console.error("Performance by user", error);
				})
				.finally((result) => {
					this.isLoading = false;
					EventBus.$emit("updateGraphWidth", true);
				});
			}
		},
		titleCase(str) {
			let splitStr = str ? str.toLowerCase().split(" ") : str;
			for (let i = 0; i < splitStr.length; i++) {
				splitStr[i] =
					splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
			}
			return splitStr.join(" ");
		},
		excerptText(text, length = 10, clamp = "...") {
			return text.length > length
				? text.toString().slice(0, length) + clamp
				: text;
		},
		reRenderGraph(data) {
			let graphColorArr = [];
			let graphLabelsArr = [];
			let graphValueArr = [];
			if(data && data.length) {
				// For audit tab
				if(this.dashboardTab == 'audit') {
					// for completion %
					if(this.selectedGraphValueType == 'completion_percentage') {
						// for location | user
						for(let i = 0; i < data.length; i++) {
							let tempObj = data[i];
							let label = tempObj.name;
							let value = tempObj.completion_rate ? tempObj.completion_rate >= 0 ? tempObj.completion_rate : tempObj.yes_no_points_percentage ? tempObj.yes_no_points_percentage >= 0 ? tempObj.yes_no_points_percentage : 0 : 0 : 0;
							let color = this.getGraphValueColor(value);
							graphColorArr.push(color);
							graphLabelsArr.push(label);
							graphValueArr.push(value);
						}
					} else if(this.selectedGraphValueType == 'score_percentage') { // for score %
						// for location | user
						for(let i = 0; i < data.length; i++) {
							let tempObj = data[i];
							let label = tempObj.name;
							let value = tempObj.yes_no_points_percentage ? tempObj.yes_no_points_percentage >= 0 ? tempObj.yes_no_points_percentage : 0 : 0;
							let color = this.getGraphValueColor(value);
							graphColorArr.push(color);
							graphLabelsArr.push(label);
							graphValueArr.push(value);
						}
					}
				} else if(this.dashboardTab == 'other') { // For task tab
					for(let i = 0; i < data.length; i++) {
						let tempObj = data[i];
						let label = tempObj.name;
						let value = tempObj.completion_rate >= 0 ? tempObj.completion_rate : 0;
						let color = this.getGraphValueColor(value);
						graphColorArr.push(color);
						graphLabelsArr.push(label);
						graphValueArr.push(value);
					}
				}
			}
			this.graphColorsArr = graphColorArr;
			this.graphLabelsArr = graphLabelsArr;
			this.graphValuesArr = graphValueArr;
			EventBus.$emit('reRenderTaskLocationGraph', true);
		},
		getGraphValueColor(val) {
			let color = '#d26300';
			// if (val <= 100 && val >= 90) {
			// 	color = "#d26300";
			// } else if (val < 90 && val >= 80) {
			// 	color = "#d67e31";
			// } else if (val < 80 && val >= 70) {
			// 	color = "#cf8c53";
			// } else if (val < 70 && val >= 60) {
			// 	color = "#d99d6a";
			// } else {
			// 	color = "#d60918";
			// }
			return color;
		}
	},
};
</script>

<style scoped>
* {
	margin: 0;
	padding: 0;
}

#chart-container {
	background: #ffffff;
	position: relative;
	height: 50vh;
	overflow: hidden;
}
</style>

<style lang="scss" scoped>
@import url("./LocationInsightsGraph.scss");
</style>
